// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"index_mainContainer__PNepC","antFormItemLabel":"index_antFormItemLabel__2YkpV"};